export default "__VITE_ASSET__CMAJt5LF__"